import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { CommitmentActionButtonProps } from '../commandActions/types'
import { LifeRollbackCommandForm } from './LifeRollbackCommandForm'

export const LifeRollbackCommand = (props: CommitmentActionButtonProps) => {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.life.useRollbackActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="life.RollbackCommandData"
      title={translate('life.rollbackEventModalButton.title')}
      commandDataForm={LifeRollbackCommandForm}
      {...props}
      submit={submit}
    />
  )
}
